export const t = {
  // 首页 nav
  'index': '首页',
  'index_contactme': '联系我们',
  'index_aboutus': '关于我们',
  'index_platform': '商户平台',
  // 首页 悬浮条
  'index_adv': '服务优势',
  'index_service': '产品与服务',
  'index_cover': '业务范围',
  'index_partner': '合作品牌',
  'index_bolo': '成为菠萝商户',
  // 首页banner 图
  'index_banner_title': '提供微信收款与营销一体化服务',
  'index_appy_but': '立即申请',
  // 首页 服务优势
  'index_adv_title': 'One Two Go的服务优势',
  'index_adv_text1_title': '便捷安全的跨境收款',
  'index_adv_text1': '消费者微信⽀付⼈⺠币，银⾏清算后，商家收到港币，具有⾦钱服务经营者牌照，资⾦流转安全可靠',
  'index_adv_text2_title': '丰富的多渠道线上宣传',
  'index_adv_text2': '多次与微信、⽀付宝、穷游、蚂蜂窝、点评、美团、携程合作',
  'index_adv_text3_title': '⽤户与商户间的多维互动',
  'index_adv_text3': '景点、导向、餐饮、购物、娱乐相互导流',
  'index_adv_text4_title': '⾼效的运维服务⽀援',
  'index_adv_text4': '⼯作⼈员24⼩时待命，随时解决问题，系统定期升级',
  'index_adv_text5_title': '专业技术研发团队⽀援',
  'index_adv_text5': '专业技术团队，保障⽀付安全，服务器可以承受数百万⽤户访问，⼤型营销事件可以⽀持，与合作伙伴的系统快速融合',
  // 首页商品与服务
  'index_service_title': 'One Two Go提供的产品与服务',
  'index_service_text1_name': '微信⽀付',
  'index_service_text1_namdes': '提供便捷的⽀付⽅式',
  'index_service_text1_desc': '⽅便快捷，简单扫码即可⽀付，深受中国旅客喜爱。⽀持多种扫码⽅式，满⾜多样化的需求。',
  'index_service_off_title': '线下微信⽀付',
  'index_service_off_desc': '刷卡⽀付、扫码⽀付、POS机融合',
  'index_service_on_title': '线上微信⽀付',
  'index_service_on_desc': 'PC⽹站⽀付、⾃助售票机⽀付、⼿机⽀付、公众号⽀付',
  // service 2
  'index_service_text2_name': '商户收款平台及APP',
  'index_service_text2_namdes': '收款便捷，营收状况清晰',
  'index_service_text2_desc': '在线⽣成业务报表，分析销售趋势，营收状况⼀⽬了然，更有超级账号可即时查看多家⻔店销售情况。⽀持双重模式收款，⽀付即时收款通知，⽀持多店员同时收款，实时查账、历史查询、销售统计。',
  // service 3
  'index_service_text3_name': '菠萝PASS',
  'index_service_text3_namdes': '提供全⽅位营销⼿段',
  'index_service_text3_desc': '为每⼀家合作商户提供线上编辑与平台展示，利⽤菠萝PASS宣传，同时结合微信公众号实现商户品牌推⼴',
  // service 4
  'index_service_text4_name': '微信公众号',
  'index_service_text4_namdes': '提供新型的品牌推⼴服务',
  'index_service_text4_desc': '开通连接中国旅客的微信公众号，品牌可透过公众号传递丰富的内容给⽤户，从⽽扩展客户市场',
  // service 5
  'index_service_text5_name': '⽹上商城',
  'index_service_text5_namdes': '提供更⽅便的销售平台',
  'index_service_text5_desc': '与公众号结合，为每个商户搭建在线商城，顾客可选购⽹上售卖商品⾃助下单完成购物，省去繁琐收单流程。',
  // 业务范围
  'index_scope_title': '全球业务',
  'index_scope_desc': '⻢来⻄亚和印尼将在2018第⼀季度开放。⽇本、韩国、澳⼤利亚和新⻄兰、法国将在2019战略部署。',
  // 部分合作品牌
  'index_brand_title': '部分合作品牌',
  'index_bolo_merchant_title': '⽴即成为Bolo商户',
  'index_input_name': '填写联系⼈姓名',
  'index_input_company': '填写公司名称',
  'index_input_company_business': '填写公司主营业务',
  'index_input_company_address': '填写公司详细地址',
  'index_input_tel': '填写联系⼈电话',
  'index_input_email': '填写联系⼈邮箱',
  'index_input_city': '填写所在城市',
  'index_input_desc': '您的留⾔',
  'index_submit': '提交',
  'index_input_desc_tips': '*申请前请了解以下细则：\n' + '\n' + '菠萝商户暂时只接受香港，泰国，马来西亚当地商户的支付申请，不接受大陆境内以及个人用户的申请，其他地区的服务正在拓展中。请填写公司信息在左边框内提交审核，信息审核通过后，将会有当地同事上门为您提供服务。\n' + '\n*如有疑问，请输入您的留言后提交',

  'index_no_name': '请输入联系人',
  'index_no_tel': '请输入电话号',
  'index_no_email': '请输入邮箱',
  'index_no_city': '请输入城市',
  'index_no_company': '请输入公司名称',
  'index_no_company_business': '请输入公司主营业务',
  'index_no_company_address': '请输入公司详细地址',
  'index_email_error': '请填入正确的邮箱格式',
  'index_input_tip_err': '信息不完整',
  'index_input_tip_succ': '申请成功',
  'index_input_tip_timer': '您提交次数太频繁，请{0}分钟后提交',
  'index_input_err_but': '继续完善信息',
  'index_input_succ_but': '知道了',

  // 国家
  'france': '法国',
  'china': '中国',
  'japan': '日本',
  'hk': '香港',
  'tailland': '泰国',
  'vietnam': '越南',
  'cambodia': '柬埔寨',
  'mala': '马来西亚',
  'newzea': '新西兰',
  'austra': '澳大利亚',
  // 页尾
  'footer_tel_label': '电话',
  'footer_email_label': '邮箱',
  'footer_adress_label': '地址',
  'footer_adress': '香港新界葵涌货柜码头路88号永得利广场2座1309室',
  'footer_bolo': '菠萝商户下载',
  'footer_wantu': '玩途⾃由⾏',
  'footer_bolo_pass': '菠萝PASS服务号',
  // 联系我们
  'connectme_hk_link': '网站',
  'connectme_connect_lab': '联系⼈',
  'connectme_connmeth_lab': '联系⽅式',
  'connectme_sha': '上海办事处',
  'connectme_sha_adress': '上海市⻓宁区中⼭⻄路930号云都虹桥⼤厦11楼B座',
  'connectme_sz': '深圳办事处',
  'connectme_sz_adress': '广东省南山区南山大道南园枫叶大厦5A1',
  'connectme_hk': '⾹港办事处',
  'connectme_hk_name': '特约服务商',
  'connectme_hk_adress': '香港新界葵涌青山道403-413號匯城集團大廈22樓C室',
  'connectme_hk_service': '戬⾠有限公司Jason Pay Limited',
  'connectme_tail': '泰国办事处',
  'connectme_taill_adress': 'The Clover Townhome. 18/82, Moo 1, T. Pa Daet, A. Muang, Chiangmai Thailand. 50100',
  'connectme_vietnam': '越南办事处',
  'connectme_vietnam_adress': '51/19/13 tue tinh,TP nha trang',
  'connectme_kuala': '吉隆坡办事处',
  'connectme_kuala_adress': 'Lot T3-11, KPMG tower, 8 First Avenue, Bandar Utama, 47800 Petaling Jaya, Selangor.',
  'connectme_sabah': '沙巴办事处',
  'connectme_sabah_adress': 'Unit no 108.First floor, Jalan asia city, Star city, Kota kinabalu, 88000, Sabah, Malaysia',
  // 关于我们
  'aboutus_wantu_title': 'FastPay介紹',
  'aboutus_wantu_p1': 'FastPay 成立於2017年8月，分別在香港、深圳、上海、北京設立辦事處，服務商戶超3000家，業務覆蓋地區包括：香港、泰國、越南、沙巴、澳洲等。 FastPay （母公司為One Two Go Co Limited、One Two Go Systems Limited附屬公司） 最初的主要業務是幫商家接入微信&支付寶線下支付，短短2年多時間，成為支付領域新力軍，之後隨著新零售模式的崛起，逐步切入跨境電商領域，助力商戶跨進新零售時代。',
  'aboutus_partner': '合作伙伴',
  'aboutus_partner_wechat': '微信⽀付',
  'aboutus_partner_alipay': '⽀付宝',
  'aboutus_partner_abc': '中国农业银⾏',
  'aboutus_partner_ccb': '中国建设银⾏',
  'aboutus_partner_cmb': '招商银⾏',
  'aboutus_partner_unpay': '中国银联',
  'aboutus_partner_visa': 'VISA',
  'aboutus_partner_master': 'Master card',
  'aboutus_partner_mafengwo': '蚂蜂窝',
  'aboutus_partner_qyer': '穷游',
  'aboutus_partner_tempus': '腾邦',
  'aboutus_partner_jason': 'Jason Pay',
  'aboutus_activity_lab': '过往活动',
  'aboutus_activity_title1': '2015年⽀付宝海外双⼗⼆狂欢节',
  'aboutus_activity_desc1': '为拓展玩途在新加坡、普吉岛、清迈、芭提雅合作的海外第三⽅⽀付市场',
  'aboutus_activity_title2': '2016年泰国餐厅5折吃⼤餐',
  'aboutus_activity_desc2': '玩途与泰国餐厅联合举办空前盛⼤活动——5折吃⼤餐',
  'aboutus_activity_title3': '2017新春三重红包好礼',
  'aboutus_activity_desc3': '玩途联⼿泰国旅游局、微信⽀付、阿狸形象，在江⻄冷举办⼤型活动',
  'aboutus_award_title': '我们的奖项',
  'aboutus_year': '年',
  'aboutus_award_p1': '⽀付宝双⼗⼆海外狂欢节，泰国唯⼀合作伙伴',
  'aboutus_award_p2': '⼿机IOS版被苹果App store四次评为“新优产品推荐”',
  'aboutus_award_p3': '⼿机的Android版获得“豌⾖荚设计奖”',
  'aboutus_award_p4': '中国旅业互联⽹风云榜最佳海外⽬的地产品预订平台',
  'aboutus_award_p5': '获得“微信⽀付合作伙伴2016年度⾏业创新奖”',
  'aboutus_award_p6': '泰国泼⽔节微信⽀付境外媒体招待玩途独家',
  'aboutus_award_p7': '菠萝通⼩程序被选为“优秀⼩程序开发代表'

}



// WEBPACK FOOTER //
// ./src/_components/i18n/zh.js